/* Numbered rows — the same numeral-and-heading idea as a procedural
   step card, at a smaller size, so "do these in order" reads the same way. */
.lead { margin: 0 0 16px; max-width: var(--measure); font: 400 15px/1.6 var(--sans); color: var(--body); }
.lead strong { color: var(--ink); }
.panel { list-style: none; margin: 0; padding: 0; display: grid; gap: 14px; max-width: var(--measure); }
.row {
  display: grid; grid-template-columns: auto 1fr; gap: 18px; align-items: start;
  padding: 20px 22px; border-radius: 14px;
  background: var(--card); box-shadow: 0 0 0 1px var(--rule);
}
.n { font: 300 44px/.85 var(--serif); color: var(--accent); min-width: 26px; }
.body { min-width: 0; }
.title { margin: 2px 0 6px; font: 400 21px/1.25 var(--serif); color: var(--ink); }
.text { margin: 0 0 14px; font: 400 14.5px/1.6 var(--sans); color: var(--body); }
.text strong { color: var(--ink); }

.primary, .primaryOff, .secondary {
  display: inline-block; border-radius: var(--radius); padding: 11px 20px;
  font: 600 12.5px var(--sans); letter-spacing: .04em; text-decoration: none;
}
.primary { background: var(--ink); color: var(--paper); }
.primary:hover { background: color-mix(in srgb, var(--ink) 82%, var(--paper)); }
.primaryOff { background: var(--ink-12, rgba(18,18,18,.12)); color: var(--ink-55); cursor: not-allowed; }
.secondary { border: 1px solid var(--ink-30); color: var(--ink); font-weight: 500; }
.secondary:hover { border-color: var(--ink); }

.userRow { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 12px; margin-bottom: 12px; }
.label { font: 600 12.5px var(--sans); color: var(--ink); }
.input {
  flex: 1 1 180px; max-width: 260px; padding: 9px 11px;
  border: 1px solid var(--ink-30); border-radius: var(--radius);
  background: var(--paper); color: var(--ink); font: 500 14px var(--mono);
}
.input:focus { outline: 2px solid var(--accent); outline-offset: 1px; border-color: var(--ink); }
.input[aria-invalid="true"] { border-color: var(--orange); }
.warn { margin: -4px 0 12px; font: 400 13px var(--sans); color: var(--ink-55); }

.actions { display: flex; flex-wrap: wrap; align-items: center; gap: 10px 18px; }
.link { font: 500 13px var(--sans); color: var(--olive); text-decoration: underline; }
.link:hover { color: var(--ink); }
.aside { margin: 12px 0 0; font: 400 13px/1.55 var(--sans); color: var(--ink-55); }
.aside strong { color: var(--ink); font-weight: 600; }

@media (max-width: 760px) {
  .row { padding: 18px 16px; gap: 12px; }
  .n { font-size: 34px; }
}
